// localhost:3000/articles/learn-node (example)
/*
useState: to store the reposne that we get back form the server
useEffect: add logic to our components that will be executed outside of the normal component rendering,
in otherwords we want to put most of our logic for doing things like loading data from a server.
*/
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios'
import NotFoundPage from './NotFoundPage';
import CommentsList from '../components/CommentsList';
// import AddCommentForm from '../components/AddCommentForm';
import TextToCogo from '../components/TextToCogoTool';
import articles from './article-content';
import useUser from '../hooks/useUser';

import {
  Container,
  Typography,
  Divider,
  Box,
  Button,
  Alert,
} from '@mui/material';

const ToolPage = () => {
    const [toolInfo, setToolInfo ] = useState({ upvotes:0, comments: [], canUpvote: false});
    const { user, isLoading } = useUser();
    const navigate = useNavigate();
    const params = useParams();
    const { canUpvote } = toolInfo; // set canUpvote from articleInfo
    const toolId = params.toolId
    // Instead of using the two line of code above you can use this line of code:
    // const { articleId } = useParams();
    
    const navigateToLogin = () => {
        navigate('/login');
    }
    
    useEffect(() => {
        const loadToolInfo = async () =>{
            try{
                console.log("from loadToolInfo")
                console.log("user: ",user)
                console.log("isLoading: ", isLoading)
                const token = user && await user.getIdToken();
                //const headers = token ? { authtoken: token } : {}; // For backend Node Express Authorization
                const headers = token ? { Authorization: "Bearer " + token} : {}; // For backend .Net 6 Web API Authorization
                // Note: frontend and backend think they are running on the same origin by setting up a proxy in the package.json file. ("http://localhost:8000/")
                const response = await axios.get(`/api/tools/${toolId}`,{ headers }) // Note: no need to use the base path "http://localhost:8000/"
                const newToolInfo = response.data;
                setToolInfo(newToolInfo);
            }catch(error){
                console.error("Failed to fetch tool info:", error);
                // Optional: fallback value or show error state
                // setToolInfo({upvotes:0,comments: [],canUpvote: false})
            }

        }
        console.log("checking isLoading condition in ToolPage component useEffect():", isLoading)
        // You are calling loadArticleInfo() when isLoading is true, but that likely means Firebase Auth is still loading, not finished.
        // You should run your logic when isLoading === false => "!isLoading"
        // Note: if users changes after "isLoading" is false (e.g. logging out and back in)
        // loadArticalInfo() might re-run prevent it by addind "!isLoading && user"
        if(!isLoading && user){
            console.log("Lets load the tool info since isLoading is ", isLoading)
            loadToolInfo();
        }
    }, [isLoading, user]);


    // Use Javascript find function to find one these articles.
    const tool = articles.find(tool => tool.name === toolId)
    console.log("Eric calling tool: ", tool)
    
    // Add function to update the article vote.
    const addUpvote = async () => {
        console.log("i voted: ", user)
        const token = user && await user.getIdToken();
        const headers = token ? { authtoken: token } : {}; // For backend Node Express Authorization
        //const headers = token ? { Authorization: "Bearer " + token} : {}; // For backend .Net 6 Web API Authorization
        // Pass null to the second argument in put request for the request body.
        const response = await axios.put(`/api/tools/${toolId}/upvote`, null, { headers }); 
        const updatedArticle = response.data;
        setToolInfo(updatedArticle)
    }

    if(!tool){
        return<NotFoundPage/>
    }

    return(
        // We will use react fragment "<> ... </>" syntax to let react know that we will be returning more hen one element
    <Container maxWidth="md" sx={{ mt: 12, mb: 8 }}>
      <Typography variant="h4" gutterBottom>
        {tool.title}
      </Typography>

      {tool.content.map((paragraph, i) => (
        <Typography key={i} paragraph>
          {paragraph}
        </Typography>
      ))}

      <Box my={4}>
        <Divider />
      </Box>

      <Box mb={3}>
        <Typography variant="h6">Upvotes</Typography>
        {user ? (
          <Button
            onClick={addUpvote}
            variant={canUpvote ? 'contained' : 'outlined'}
            disabled={!canUpvote}
            sx={{ mt: 1 }}
          >
            {canUpvote ? 'Upvote' : 'Already Upvoted'}
          </Button>
        ) : (
          <Button onClick={navigateToLogin} variant="outlined" sx={{ mt: 1 }}>
            Log in to upvote
          </Button>
        )}
        <Typography variant="body2" sx={{ mt: 1 }}>
          This article has <strong>{toolInfo.upvotes}</strong> upvote(s)
        </Typography>
      </Box>

      <Divider sx={{ my: 4 }} />

      <Box mb={3}>
                <Typography variant="h6">Insert Legal Descriptions </Typography>
        {user ? (
          <TextToCogo/>
        ) : (
          <Alert severity="info" sx={{ mt: 2 }}>
            You must <Button onClick={navigateToLogin}>log in</Button> to add a legal description.
          </Alert>
        )}
        {/* <CommentsList comments={toolInfo.comments} /> */}
      </Box>
    </Container> 
    )
}

export default ToolPage;